import { render, staticRenderFns } from "./CreateChannel.vue?vue&type=template&id=166b2f8c"
import script from "./CreateChannel.vue?vue&type=script&lang=js"
export * from "./CreateChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports